import { blockSettingFieldTypes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'

import BlockSettingBooleanField from './BlockSettingBooleanField/BlockSettingBooleanField'
import BlockSettingColorField from './BlockSettingColorField/BlockSettingColorField'
import BlockSettingImageField from './BlockSettingImageField/BlockSettingImageField'
import BlockSettingNumberField from './BlockSettingNumberField/BlockSettingNumberField'
import BlockSettingSelectField from './BlockSettingSelectField/BlockSettingSelectField'
import BlockSettingTextareaField from './BlockSettingTextareaField/BlockSettingTextareaField'
import BlockSettingTextField from './BlockSettingTextField/BlockSettingTextField'
import BlockSettingTranslatedTextField from './BlockSettingTranslatedTextField/BlockSettingTranslatedTextField'

const BlockSettingField = ({ field, value, onChange, onUploadImage, canUploadImage }) => {
  if (field.type === blockSettingFieldTypes.boolean) {
    return <BlockSettingBooleanField field={field} value={value} onChange={onChange} />
  }

  if (field.type === blockSettingFieldTypes.translatedText) {
    return <BlockSettingTranslatedTextField field={field} value={value} onChange={onChange} />
  }

  if (field.type === blockSettingFieldTypes.text) {
    return <BlockSettingTextField field={field} value={value} onChange={onChange} />
  }

  if (field.type === blockSettingFieldTypes.image) {
    return (
      <BlockSettingImageField
        field={field}
        value={value}
        onChange={onChange}
        onUploadImage={onUploadImage}
        canUploadImage={canUploadImage}
      />
    )
  }

  if (field.type === blockSettingFieldTypes.color) {
    return <BlockSettingColorField field={field} value={value} onChange={onChange} />
  }

  if (field.type === blockSettingFieldTypes.textarea) {
    return <BlockSettingTextareaField field={field} value={value} onChange={onChange} />
  }

  if (field.type === blockSettingFieldTypes.number) {
    return <BlockSettingNumberField field={field} value={value} onChange={onChange} />
  }

  if (field.type === blockSettingFieldTypes.select) {
    return <BlockSettingSelectField field={field} value={value} onChange={onChange} />
  }

  return null
}

export default BlockSettingField
